import { render, staticRenderFns } from "./IframeTemplate.vue?vue&type=template&id=426d652b&scoped=true&"
import script from "./IframeTemplate.vue?vue&type=script&lang=js&"
export * from "./IframeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./IframeTemplate.vue?vue&type=style&index=0&id=426d652b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426d652b",
  null
  
)

export default component.exports